const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "Waiting Until the Last Minute",
    desc: "UND students and faculty often plan international trips on short notice. Standard processing takes 6–11 weeks. Start at least 3 months before your departure date.",
  },
  {
    icon: "ri-camera-off-line",
    title: "Using a Non-Compliant Photo",
    desc: "Selfies, wrong dimensions, or glasses in the frame are the #1 rejection reason. Grand Forks has several passport photo locations — we'll direct you to the right one.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Submitting Incomplete Documents",
    desc: "Missing birth certificates, expired IDs, or wrong form versions cause instant rejections. Our agents review your full packet before submission.",
  },
  {
    icon: "ri-map-2-line",
    title: "Driving 330 Miles to Minneapolis Unnecessarily",
    desc: "Many Grand Forks residents assume they must drive to Minneapolis for expedited processing. That trip is only for true emergencies — Fast Passport Center handles expedited remotely.",
  },
  {
    icon: "ri-hand-coin-line",
    title: "Paying the Wrong Fee",
    desc: "Passport fees vary by age, type, and service. Sending the wrong check amount causes delays. We calculate and verify the exact fees for your application.",
  },
  {
    icon: "ri-global-line",
    title: "International Students Missing Deadlines",
    desc: "UND international students often need visas and passports aligned precisely. Missing a passport renewal deadline can void visa applications. Let us handle the timing.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Mistakes Grand Forks Travelers Make
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Avoid these common pitfalls that delay or reject passport applications for northeastern North Dakota residents.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-500 text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}